import Calender3DIcon from '@/assets/icons/calender3DIcon.png';
import Clipboard3DIcon from '@/assets/icons/clipboard3DIcon.png';
import DeliveryBox3DIcon from '@/assets/icons/deliveryBox3DIcon.png';
import SpaceShuttle3DIcon from '@/assets/icons/spaceShuttle3DIcon.png';
import { Box, Grid2 as Grid, Stack, Typography } from '@mui/material';
import React from 'react';
const PROCESS = [
    {
        img: React.createElement("img", { src: Clipboard3DIcon, alt: "check", style: { width: '30px' } }),
        title: 'Today',
        description: 'Access GrantMatch to review your grant results. Check your email for a sign up link.',
    },
    {
        img: React.createElement("img", { src: DeliveryBox3DIcon, alt: "delivery box", style: { width: '40px' } }),
        title: 'After signup',
        description: 'Review your grants and even explore all grant options with our Browse Features.',
    },
    {
        img: React.createElement("img", { src: Calender3DIcon, alt: "calendar", style: { width: '50px' } }),
        title: 'Tomorrow',
        description: 'Meet your grant adviser to schedule your strategy session.',
    },
    {
        img: React.createElement("img", { src: SpaceShuttle3DIcon, alt: "space shuttle", style: { width: '22px' } }),
        title: 'Next week',
        description: 'Start executing on your grant pipeline.',
    },
];
export const SignupProcess = () => {
    return (React.createElement(Grid, { container: true, spacing: 3 }, PROCESS.map((item) => (React.createElement(Grid, { key: item.title, size: { xs: 12 } },
        React.createElement(Stack, { gap: 1.5, direction: "row" },
            React.createElement(Box, { sx: {
                    width: '70px',
                    height: '70px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } }, item.img),
            React.createElement(Box, null,
                React.createElement(Typography, { mb: 0.8, fontWeight: 600, fontSize: "0.9rem", color: "secondary" }, item.title),
                React.createElement(Typography, { fontWeight: 500, fontSize: "0.9rem", color: "secondary.light" }, item.description))))))));
};
